import { useDataValue, useDataSubmit } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { isSameDay } from 'date-fns'

export function useOnClick(props) {
  let date = useDataValue({
    context: 'date',
    path: 'date',
    viewPath: props.viewPath,
  })
  let submitTab = useDataSubmit({
    viewPath: props.viewPath,
    context: 'tab',
  })
  let tabDate = useDataValue({
    context: 'tab',
    path: 'selected.date',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick() {
    setFlowTo(normalizePath(props.viewPath, '../../../../No'))

    if (isSelected(date, tabDate)) return
    submitTab({
      type: 'setDate',
      date,
    })
  }
}

/**
 * @param {string} date_date
 * @param {Date} selected_date
 * @returns {boolean}
 */
export function isSelected(date, selectedDate) {
  return isSameDay(date, selectedDate)
}
